enum AccountApprovalStatusEnum {
    Approved = 'APPROVED',
    Draft = 'DRAFT',
    Legacy = 'LEGACY',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
}

export default AccountApprovalStatusEnum;
